export default "__VITE_ASSET__BYyb9Rt$__"